import React from "react";

type Props = {};

const Hasaccount = (props: Props) => {
  return (
    <>
      <div className=" mt-[4px] mx-[4px]"></div>
    </>
  );
};

export default Hasaccount;
